export const energyOptions = [
  {
    id: 'solar',
    description: 'service_solar_description',
    imgSrc: require('assets/icons/solar_panels.svg').default,
    img2Src: require('assets/icons/solar_panels_2.svg').default,
    type: 'energySolution',
    available: true,
    recommendedString: 'service_solar_recommended_string',
    notInterestedString: 'service_solar_notinterested_string'
  },
  {
    id: 'glass',
    description: 'service_glass_description',
    imgSrc: require('assets/icons/glass_insulation.svg').default,
    img2Src: require('assets/icons/glass_insulation_2.svg').default,
    type: 'energyLossPrevention',
    available: true,
    recommendedString: 'service_glass_recommended_string',
    notInterestedString: 'service_glass_notinterested_string',
    types: ['Enkelglas', 'Dubbelglas begane grond', 'Dubbelglas hele huis', 'HR++']
  },
  {
    id: 'wall',
    description: 'service_wall_description',
    imgSrc: require('assets/icons/cavity_insulation.svg').default,
    img2Src: require('assets/icons/cavity_insulation_2.svg').default,
    type: 'energyLossPrevention',
    available: true,
    recommendedString: 'service_wall_recommended_string',
    notInterestedString: 'service_wall_notinterested_string',
    types: ['Niet geïsoleerd', 'Matig geïsoleerd', 'Goed geïsoleerd']
  },
  {
    id: 'roof',
    description: 'service_roof_description',
    imgSrc: require('assets/icons/roof_insulation.svg').default,
    img2Src: require('assets/icons/roof_insulation_2.svg').default,
    type: 'energyLossPrevention',
    available: true,
    recommendedString: 'service_roof_recommended_string',
    notInterestedString: 'service_roof_notinterested_string',
    types: ['Niet geïsoleerd', 'Matig geïsoleerd', 'Goed geïsoleerd']
  },
  {
    id: 'ground',
    description: 'service_ground_description',
    imgSrc: require('assets/icons/floor_insulation.svg').default,
    img2Src: require('assets/icons/floor_insulation_2.svg').default,
    type: 'energyLossPrevention',
    available: true,
    recommendedString: 'service_ground_recommended_string',
    notInterestedString: 'service_ground_notinterested_string',
    types: ['Niet geïsoleerd', 'Matig geïsoleerd', 'Goed geïsoleerd']
  },
  {
    description: 'service_homebattery_description',
    imgSrc: require('assets/icons/home_battery.svg').default,
    img2Src: require('assets/icons/home_battery_2.svg').default,
    type: 'energySolution',
    available: false,
    notAvailableString: 'service_homebattery_unavailable_string',
    notInterestedString: 'service_homebattery_notinterested_string'
  },
  {
    description: 'service_waterpump_description',
    imgSrc: require('assets/icons/water_pump.svg').default,
    img2Src: require('assets/icons/water_pump_2.svg').default,
    type: 'energySolution',
    available: false,
    notAvailableString: 'service_waterpump_unavailable_string',
    notInterestedString: 'service_waterpump_notinterested_string'
  },
  {
    description: 'service_chargingstation_description',
    imgSrc: require('assets/icons/charging_station.svg').default,
    img2Src: require('assets/icons/charging_station_2.svg').default,
    type: 'energySolution',
    available: false,
    notAvailableString: 'service_chargingstation_unavailable_string',
    notInterestedString: 'service_chargingstation_notinterested_string'
  }
]

export const familySizeOptions = [
  { label: '1 personen', value: { kwh: 1100, gas: 1000, size: 1 } },
  { label: '2 personen', value: { kwh: 2800, gas: 1200, size: 2 } },
  { label: '3 personen', value: { kwh: 3300, gas: 1500, size: 3 } },
  { label: '4 personen', value: { kwh: 3800, gas: 1700, size: 4 } },
  { label: '5+ personen', value: { kwh: 4100, gas: 1900, size: 5 } }
]

export const stepEnums = {
  1: 'Step 1 - Address',
  2: 'Step 2 - Flow menu',
  8: 'Step 2 Error - Address not found',
  3: 'Step 3 - Address confirmation',
  4: 'Step 4 - Consumption/Services manu',
  5: 'Step 5 - Personal Advice',
  6: 'Step 6 - Advice details',
  7: 'Step 7 - Offer sent final step',
  10: 'DCT Step 1 - Address confirmation',
  11: 'DCT Step 2 - Consumption',
  12: 'DCT Step 3 - Results',
  19: 'DCT Step 3 Error - Results Error',
  13: 'DCT Step 4 - Results confirmation',
  15: 'DCT Step 2A - Manual Offer',
  16: 'DCT Step 5 - Offer sent final step'
}
